export default __webpack_public_path__ + "static/media/coffeescript.848d1c77.svg";